var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdeaLightbulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-0.952997 0.30298 0.30298 0.952997 36.8711 16.0039)",
    fill: "#FFC061"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4615 21.993C21.9104 13.0879 36.8999 15.0475 39.0409 24.8303C40.3328 30.7332 34.8856 34.8643 34.182 40.3921H21.6944C21.3273 38.914 20.5802 37.1561 20.0628 36.0756C18.9876 33.8308 17.4667 32.3635 16.8893 29.8592C16.3399 27.4763 16.4035 24.1111 17.4615 21.993Z",
    stroke: "black",
    strokeWidth: 3.07031,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4126 47.9256C34.4161 46.2199 34.4998 44.5142 34.4702 42.809C34.4585 42.1338 34.5738 41.3078 33.9894 40.8357C33.1361 40.1467 31.8667 40.0463 30.8077 40.0208C28.8227 39.9733 26.8225 39.99 24.8356 39.9941C23.9306 39.9956 22.5801 39.8385 21.7645 40.2882C20.9882 40.7154 20.7917 41.8799 20.7044 42.6665C20.537 44.1736 20.0914 47.5392 21.371 48.7059C22.1769 49.4409 23.434 49.5946 24.466 49.7217C27.2038 50.0586 34.4085 49.9917 34.4126 47.9256Z",
    stroke: "black",
    strokeWidth: 3.07031,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1204 49.8672C27.0981 50.7955 27.0871 51.7287 27.1602 52.6555",
    stroke: "black",
    strokeWidth: 3.07031,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7656 35.6943C47.7916 35.1803 46.7744 34.7573 45.79 34.2656",
    stroke: "black",
    strokeWidth: 3.07031,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7695 15.7148C47.6823 16.4052 46.6422 17.1682 45.5525 17.8527",
    stroke: "black",
    strokeWidth: 3.07031,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3038 7.53325C27.342 6.16587 27.3336 4.80829 27.2899 3.44141",
    stroke: "black",
    strokeWidth: 3.07031,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4805 16.848C9.11557 15.9445 7.70995 15.0957 6.32171 14.2285",
    stroke: "black",
    strokeWidth: 3.07031,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8594 35.4805C11.8069 36.4237 10.7499 37.356 9.73124 38.3359",
    stroke: "black",
    strokeWidth: 3.07031,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaLightbulb);
export default __webpack_public_path__ + "static/media/idea-lightbulb.420a4d7a4ec2446689b50b91d27d61f1.svg";
export { ForwardRef as ReactComponent };